import React from 'react';
import { Frame } from "scenejs";
import _ from 'lodash';
import { CAROUSEL_CARD, IMAGE, CONTENT_CARD } from '../../constants/widgetTypes';
const PARENTS_DISALLOWING_IMAGE_TRANSFORMATIONS = [CONTENT_CARD];
export const HIGH_PRIORITY_RESOURCE_THRESHOLD = 800;
export const SPINNER_CLASS = 'widget-triggers-loading';

export function getStylesForLayout(layout, breakpoint, container, parentContainer) {
  var widgetStyle = new Frame(layout).toCSSObject();

  if (container) {
    const minWidth = _.get(container, `properties.${breakpoint}.container.minWidth`);
    const alignment = _.get(container, `properties.${breakpoint}.container.alignment.position`) || _.get(container, `properties.${breakpoint}.container.alignment`, 'center');

    var multiplier = 0.5;
    switch (alignment) {
      case 'left':
        multiplier = 0;
        break;

      case 'right':
        multiplier = 1;
        break;

      case 'center':
      default:
        multiplier = 0.5;
        break;
    }

    widgetStyle = {
      ...widgetStyle,
      marginLeft: !minWidth ? '0px' : `calc((100% - ${minWidth}px) * ${multiplier})`
    }

    if (container?.type === CAROUSEL_CARD) {
      const parentWidget = parentContainer;
      const isFreeSize = _.get(parentWidget, `properties.desktop.free`, false);

      if (isFreeSize) {

        widgetStyle = {
          ...widgetStyle,
          marginLeft: '0px'
        }
      }
    }
  }

  return widgetStyle;
}

export function colorToString(color) {
  if (!color) {
    return "inherit";
  }

  return `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`;;
}

// Replace if aktiv-grotesk font is found
export function injectAktivFallback(content) { 
  if (!content || typeof content !== "string") {
    return content;
  }
  return content.replace(/\baktiv-grotesk\b/g, 'aktiv-grotesk, aktivGrotesk');
}

export const isActionTriggerLoading = (action) => {
  if (!action) return false;
  switch (action.type) {
    case 'link':
    case 'page':
      return !action.newTab;
    default:
      return false;
  }
}

export const getChildWidgetProps = (childWidgetProps, parentType) => {
  const shouldDisableTransformations = childWidgetProps.type === IMAGE && PARENTS_DISALLOWING_IMAGE_TRANSFORMATIONS.includes(parentType);
  
  if (shouldDisableTransformations) {
    const widgetProps = _.cloneDeep(childWidgetProps);
    // Disable image transformations to prevent redundant network requests for the same resource.
    widgetProps.noTransformations = true;
    return widgetProps;
  }

  return childWidgetProps;
}

function getY(layout){
  if (!layout) {
    return 0;
  }

  const frame = new Frame(layout);
  const translate = frame.get("transform", "translate") || '0px, 0px';
  const position = translate.split(",").map(str => {
    str = str.trim();
    return parseFloat(str);
  });

  return position[1];
}

export const getYForWidget = (widget, widgetsById) => {
  if (!widget.parent) {
    return getY(widget?.properties?.desktop?.layout);
  }

  let currentY = getY(widget?.properties?.desktop?.layout);
  
  const parentWidget = widgetsById[widget.parent];

  if (parentWidget) {
    const parentTotalY = getYForWidget(parentWidget, widgetsById);
    
    return currentY + parentTotalY;
  }

  return currentY;
}